<div class="mb-1 row">
    <div class="col">
        <ng-select *ngIf="!favoriteLocation"
                   name="dropdownStorageLocation"
                   id="dropdownStorageLocation"
                   [(ngModel)]="storageLocIdSelected"
                   [items]="storageLocations | async"
                   [bindLabel]="'name'"
                   [bindValue]="'id'"
                   (change)="onValueChanged($event)"
                   [clearable]="false"
                   required>
        </ng-select>

        <ng-select *ngIf="favoriteLocation"
                   name="dropdownFavoriteLocation"
                   id="dropdownFavoriteLocation"
                   [(ngModel)]="favoriteLocIdSelected"
                   [items]="favoriteLocations | async"
                   [bindLabel]="'name'"
                   [bindValue]="'id'"
                   (change)="onValueChanged($event)"
                   [clearable]="false"
                   required>
        </ng-select>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="form-check">
            <input type="checkbox" class="form-check-input" [(ngModel)]="favoriteLocation" name="favoriteLocations" id="favoriteLocations" (change)="onValueChanged($event)">
            <label class="form-check-label" for="favoriteLocations" jhiTranslate="inventoryManagerApp.lot.locationName.favorite">
                Favorite locations only
            </label>
        </div>
    </div>
</div>
